module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal is-active"
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card h-100"
  }, [(_vm.loading) ? _c('p', [_vm._v("Loading...")]) : _c('section', {
    staticClass: "modal-card-body d-block br-1"
  }, [_c('header', {
    staticClass: "d-flex align-items-center pb-3 space-between"
  }, [_c('h2', {
    staticClass: "fs-8"
  }, [_vm._v("Share this folder")]), _vm._v(" "), _c('button', {
    staticClass: "delete",
    on: {
      "click": _vm.close
    }
  })]), _vm._v(" "), _c('section', [_c('p', [_vm._v("Select people or teams to share your video with from the dropdown. Start typing a name to filter the results.")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('div', {
    staticClass: "w-100 mr-2"
  }, [_c('v-select', {
    staticClass: "v-select mt-0",
    attrs: {
      "multiple": "",
      "label": "value",
      "options": _vm.shareables
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(option) {
        return [_c('span', [(option.team) ? _c('b', [_vm._v("Group:")]) : _vm._e(), _vm._v(" " + _vm._s(option.value))])]
      }
    }]),
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "button is-primary is-medium",
    class: {
      'is-loading': _vm.sharingWithSelected
    },
    attrs: {
      "type": "button",
      "disabled": _vm.selected.length === 0,
      "name": "Share"
    },
    on: {
      "click": _vm.shareFolder
    }
  }, [_vm._v("\n            Share\n          ")])])]), _vm._v(" "), _c('section', [_c('hr'), _vm._v(" "), (_vm.showShareText) ? _c('p', {
    staticClass: "text-center text-italic"
  }, [_vm._v("\n          This folder isn't shared with any person or team.\n        ")]) : _c('h1', {
    staticClass: "fs-6 text-center"
  }, [_vm._v("Shared With:")]), _vm._v(" "), _c('ul', {
    staticClass: "overflow-auto mh-35"
  }, [_vm._l((_vm.folder.shares), function(fs) {
    return _c('li', {
      staticClass: "mb-1 d-flex justify-content-between"
    }, [_vm._v("\n            " + _vm._s(fs.user.name || fs.user.email) + "\n             "), _c('input', {
      staticClass: "button is-small is-danger is-outlined",
      class: {
        'is-loading': fs.unsharing, 'w-auto': true
      },
      attrs: {
        "type": "button",
        "value": "✕ Unshare"
      },
      on: {
        "click": function($event) {
          _vm.unshareFolder(fs.id)
        }
      }
    })])
  }), _vm._v(" "), _vm._l((_vm.folder.teamshares), function(ts) {
    return _c('li', {
      staticClass: "mb-1 d-flex justify-content-between"
    }, [_c('div', [_c('b', [_vm._v("Group:")]), _vm._v(" " + _vm._s(ts.name))]), _vm._v(" "), _c('input', {
      staticClass: "button is-small is-danger is-outlined",
      class: {
        'is-loading': ts.unsharing, 'w-auto': true
      },
      attrs: {
        "type": "button",
        "value": "✕ Unshare"
      },
      on: {
        "click": function($event) {
          _vm.unshareTeamFolder(ts.id)
        }
      }
    })])
  })], 2)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-465fb3c2"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ShareFolderModal.vue
// module id = 1021
// module chunks = 0